import React from "react";
import { Link, useRouteMatch } from "react-router-dom";
import PropTypes from "prop-types";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExternalLinkAlt } from "@fortawesome/free-solid-svg-icons";

import * as DocumentationUtils from "../../Utils/DocumentationUtils";

const SideBarItem = (props) => {

    let match = useRouteMatch({
        path: DocumentationUtils.removeSearchParamsFromUri(props.to),
        exact: true
    });

    let classname = match ? "sidebar-link active" : "sidebar-link";

    let link = (<Link to={props.to} className={classname} >{props.children}</Link>);
    let externalLink = (<a
        href={props.to}
        className={classname}
        target="_blank"
        rel="noopener noreferrer"
    >
        {props.children}
        <FontAwesomeIcon icon={faExternalLinkAlt} fixedWidth className="ml-2" color="#006394" />
    </a>);

    return (
        <li>
            {props.externalLink ? externalLink : link}
        </li>
    );
}

SideBarItem.propTypes = {
    to: PropTypes.string,
    externalLink: PropTypes.bool,
};

SideBarItem.defaultProps = {
    externalLink: false,
}

export default SideBarItem;